// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2nsmR","calendarButtons":"ClockData_calendarButtons__1I292"};